// Web prices come from the server (/api/paypal/config, see lib/webPrices.js)
// in the visitor's currency; nothing here may hard-code an amount.
export const MONTH_LABEL = {
    en: '/ mo', da: '/ md', no: '/ md', sv: '/ mån', de: '/ Mo', nl: '/ mnd',
    fr: '/ mois', es: '/ mes', it: '/ mese', pt: '/ mês', pl: '/ mies.',
};

// Monthly AI points for (PayPal/legacy) Premium. Must match the backend
// default AI_PREMIUM_MONTHLY_UNITS in services/ai_meter.py; the server is the
// authority and the Shed shows the live balance from /api/ai/allowance.
export const PREMIUM_AI_POINTS = 350;
